// home.js window.loadApp(url, token): opens an eCOS application (Assort, Backoffice v2) in this window by posting
// the user's token to its login form, so the token never shows in a URL.
export function postTokenForm(url, token, doc = document) {
	const form = doc.createElement('form');
	form.method = 'POST';
	form.action = url;
	form.style.display = 'none';

	const input = doc.createElement('input');
	input.type = 'hidden';
	input.name = 'token';
	input.value = token;

	form.appendChild(input);
	doc.body.appendChild(form);
	form.submit();
}
